import { ScenarioCostPostDTO } from '@luminovo/http-client';
import { Row } from '../../types/rowTypes';
import { convertRowsToTableColumns } from './convertRowsToTableColumns';
import { convertTableColumnsToCosts } from './convertTableColumnsToCosts';

export const convertRowsToCosts = (rows: Row[], isCalculationWithoutManufacturing: boolean): ScenarioCostPostDTO[] => {
    const columns = convertRowsToTableColumns(rows, isCalculationWithoutManufacturing);
    return convertTableColumnsToCosts(columns);
};
